import React, { PropsWithChildren, useMemo, useState } from 'react';
import { CustomDragLayer } from './CustomDragLayer/CustomDragLayer';
import {
  Callback,
  DragAndDropContextProvider,
  DragAndDropContextState,
  DragAndDropContextType,
} from './partials/DragAndDropContext';
import { useSubscribe } from '../Subscribe/useSubscribe';

export function DragAndDropProvider({ children }: PropsWithChildren<unknown>) {
  const [draggedItem, setState] = useState<DragAndDropContextState | null>(null);
  const [newMousePosition, subscribeForNewMousePosition] = useSubscribe<Callback>();
  const DragAndDropProviderValue = useMemo<DragAndDropContextType>(() => {
    return {
      draggedItem,
      subscribeForNewMousePosition,
      newMousePosition,
      setDraggedItem: (item: DragAndDropContextState) => {
        setState(item);
      },
      resetDraggedItem: () => setState(null),
    };
  }, [draggedItem, subscribeForNewMousePosition, newMousePosition]);

  return (
    <div className="drag-and-drop-provider">
      <DragAndDropContextProvider value={DragAndDropProviderValue}>
        {children}
        <CustomDragLayer />
      </DragAndDropContextProvider>
    </div>
  );
}
